import { useEffect } from 'react';
import { useTheme } from 'styled-components';
import useDatePicker from '../../../1_application/core/components/buttons/useDatePicker';
import BoxContainer from '../../core/components/box/boxContainer';
import FlexBox from '../../core/components/box/flexBox';
import Row from '../../core/components/box/row';
import SizedBox from '../../core/components/box/sizedBox';
import LXLowButton from '../../core/components/buttons/lxLowButton';
import { LXLabelInput } from '../../core/texts/lxInput';
import { LXh5 } from '../../core/texts/lxText';

interface DateRangeFormProps {
  onApply: (beginDate: Date, endDate: Date) => () => Promise<void>;
  isDisplay: boolean;
}

const DateRangeForm = (props: DateRangeFormProps) => {
  const beginDate = useDatePicker({
    isNew: true,
    base: undefined,
  });
  const endDate = useDatePicker({ isNew: true, base: undefined });
  const theme = useTheme();

  useEffect(() => {
    if (!props.isDisplay) {
      beginDate.setNew();
      endDate.setNew();
    }
  }, [beginDate, endDate, props.isDisplay]);

  return (
    <BoxContainer
      borderRadius="0px"
      padding="24px 127px"
      backgroundColor={theme.colors.dateBg}
      isDisplay={props.isDisplay}
    >
      <Row alignItems="center">
        <LXLabelInput
          placeholder={'dd'}
          label={theme.texts.from}
          width={80}
          value={beginDate.day}
          onValidate={beginDate.setIsDayValid}
          validate={beginDate.dayValidate}
          onChange={beginDate.setDay}
          validateDelay={10}
          tabIndex={1}
        ></LXLabelInput>
        <SizedBox width={8}></SizedBox>
        <LXLabelInput
          placeholder={'mm'}
          label={''}
          width={80}
          value={beginDate.month}
          onValidate={beginDate.setIsMonthValid}
          validate={beginDate.monthValidate}
          onChange={beginDate.setMonth}
          validateDelay={10}
          tabIndex={2}
        ></LXLabelInput>
        <SizedBox width={8}></SizedBox>
        <LXLabelInput
          placeholder={'yyyy'}
          label={''}
          width={96}
          value={beginDate.year}
          onValidate={beginDate.setIsYearValid}
          validate={beginDate.yearValidate}
          onChange={beginDate.setYear}
          validateDelay={10}
          tabIndex={3}
        ></LXLabelInput>
        <SizedBox width={8}></SizedBox>
        <LXh5>{'~'}</LXh5>
        <SizedBox width={8}></SizedBox>
        <LXLabelInput
          placeholder={'dd'}
          label={theme.texts.to}
          width={80}
          value={endDate.day}
          onValidate={endDate.setIsDayValid}
          validate={endDate.dayValidate}
          onChange={endDate.setDay}
          validateDelay={10}
          tabIndex={4}
        ></LXLabelInput>
        <SizedBox width={8}></SizedBox>
        <LXLabelInput
          placeholder={'mm'}
          label={''}
          width={80}
          value={endDate.month}
          onValidate={endDate.setIsMonthValid}
          validate={endDate.monthValidate}
          onChange={endDate.setMonth}
          validateDelay={10}
          tabIndex={5}
        ></LXLabelInput>
        <SizedBox width={8}></SizedBox>
        <LXLabelInput
          placeholder={'yyyy'}
          label={''}
          width={96}
          value={endDate.year}
          onValidate={endDate.setIsYearValid}
          validate={endDate.yearValidate}
          onChange={endDate.setYear}
          validateDelay={10}
          tabIndex={6}
        ></LXLabelInput>
        <FlexBox></FlexBox>
        <LXLowButton
          alignSelf="flex-end"
          disabled={
            beginDate.isDayValid &&
            beginDate.isMonthValid &&
            beginDate.isYearValid &&
            endDate.isDayValid &&
            endDate.isMonthValid &&
            endDate.isYearValid
              ? false
              : true
          }
          onClick={props.onApply(
            new Date(
              beginDate.year + '-' + beginDate.month + '-' + beginDate.day
            ),
            new Date(endDate.year + '-' + endDate.month + '-' + endDate.day)
          )}
        >
          {theme.texts.apply}
        </LXLowButton>
      </Row>
    </BoxContainer>
  );
};

export default DateRangeForm;
